
const errors = {
  // Errors
  errors: {
    invalidUrlParameters: "Invalid URL parameters",
    loadMatchDetailsFailed: "Failed to load match details. Please try again later.",
    error: "Error"
  }
};

export default errors;
